import { Button } from "@/components/ui/button"
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/components/ui/dialog"
import { useSemanticColors } from "@/hooks/useSemanticColors"
import { Text } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  colorScheme?: string
  loading?: boolean
}

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  colorScheme = "red",
  loading = false,
}: ConfirmDialogProps) => {
  const { t } = useTranslation("common")
  const sc = useSemanticColors()

  return (
    <DialogRoot
      open={open}
      onOpenChange={(details) => {
        if (!details.open) onClose()
      }}
      size={{ base: "sm", md: "md" }}
      role="alertdialog"
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle color={sc.heading}>{title}</DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          <Text color={sc.text}>{message}</Text>
        </DialogBody>
        <DialogFooter gap={3}>
          <Button
            colorScheme={colorScheme}
            onClick={() => {
              onConfirm()
              onClose()
            }}
            loading={loading}
          >
            {confirmLabel || t("actions.confirm")}
          </Button>
          <Button onClick={onClose} disabled={loading}>
            {cancelLabel || t("actions.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}

export default ConfirmDialog
